import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/InstructorViewSubmission/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, MenuItem, Select, Stack, styled, Text } from 'shell/components';

const Header = () => {
    const { t } = useTranslation();
    const { device } = useViewport();

    const {
        viewableSubmissions,
        currentSubmission,
        selectedFileId,
        isEditing,
        onClickBack,
        onChangeSubmission,
        viewPrevSubmission,
        viewNextSubmission,
    } = useContext(PageContext);

    const currentSubmissionIndex = viewableSubmissions.findIndex(({ id }) => id === currentSubmission.id);
    const currentFile = currentSubmission.files.find(({ id }) => id === selectedFileId);

    const NavigationControls = (
        <CustomStack alignItems={'flex-end'} device={device} direction={'row'} spacing={2}>
            <Select
                disabled={isEditing}
                label={
                    <Text component={'h1'}>
                        {t('ui.viewing', 'Viewing')} {currentSubmissionIndex + 1}/{viewableSubmissions.length}
                    </Text>
                }
                labelId={currentSubmission.id}
                value={currentSubmission.id}
                onChange={onChangeSubmission}
            >
                {viewableSubmissions.map((submission) => {
                    return (
                        <MenuItem key={submission.id} value={submission.id}>
                            {submission?.api?.user?.id
                                ? submission?.api?.user?.name || submission?.api?.user?.id || ''
                                : currentFile?.original_file
                                  ? currentFile?.original_file.name
                                  : currentFile?.name}
                        </MenuItem>
                    );
                })}
            </Select>
            <IconButton
                aria-label={'view previous submission'}
                disabled={isEditing || currentSubmissionIndex === 0}
                kind={'chevronLeft'}
                size={'medium'}
                variant={'square'}
                onClick={viewPrevSubmission}
            />
            <IconButton
                aria-label={'view next submission'}
                disabled={isEditing || currentSubmissionIndex === viewableSubmissions.length - 1}
                kind={'chevronRight'}
                size={'medium'}
                variant={'square'}
                onClick={viewNextSubmission}
            />
        </CustomStack>
    );

    const CloseIconButton = (
        <IconButton
            aria-label={'close'}
            disabled={isEditing}
            kind={'exit'}
            size={'medium'}
            variant={'square'}
            onClick={onClickBack}
        />
    );

    return (
        <RootStack
            alignItems={device === 'mobile' ? 'flex-end' : 'center'}
            device={device}
            direction={device === 'mobile' ? 'column-reverse' : 'row'}
            justifyContent={'space-between'}
            spacing={device === 'mobile' ? 2 : 0}
        >
            {NavigationControls}
            {CloseIconButton}
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme, device }) => {
    return {
        position: 'absolute',
        top: 0,
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: device === 'mobile' ? '129px' : '81px',
        padding: device === 'desktop' ? theme.spacing(3, 5) : theme.spacing(3, 4),
        background: theme.palette.ensightful.primary[50],
    };
});

const CustomStack = styled(Stack)(({ device }) => {
    return {
        ...(device === 'mobile' && {
            width: '100%',
        }),
        ...(device === 'tablet' && {
            width: '300px',
        }),
        ...(device === 'desktop' && {
            width: '500px',
        }),
    };
});

export default Header;
